import { render, staticRenderFns } from "./CardExpansion.vue?vue&type=template&id=36648560"
import script from "./CardExpansion.vue?vue&type=script&lang=ts"
export * from "./CardExpansion.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports